export enum DriverLocationOrigin {
  mobile = 'mobile',
  web = 'web',
  gps = 'gps',
}
